import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './modules/home/home.component';
import { BarclayResponseComponent } from './modules/service-order/components/barclay-response/barclay-response.component';
import { MasterDataComponent } from './modules/home/modules/master-data/master-data.component';
import { authGuard } from './shared/services/auth.guard';

const routes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [authGuard], loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule)},
  { path: 'master-data', component: MasterDataComponent, canActivate: [authGuard], loadChildren: () => import('./modules/home/modules/master-data/master-data.module').then((m) => m.MasterDataModule)},
  { path: 'service-order', canActivate: [authGuard], loadChildren: () => import('./modules/service-order/service-order.module').then((m) => m.ServiceOrderModule)},
  { path: 'barclay-response', component: BarclayResponseComponent, canActivate: [authGuard]},
  { path: '**', redirectTo: 'home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
